import React, { useEffect, useState } from "react";

import styles from "./PreviousEvents.module.css";
import client from "../../config/contentful.js";
import SimpleSlider from "../../Components/Slider/Slider.js";
import Page from "../../Components/Page/Page.js";

function PreviousEventsPage() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    client
      .getEntries({
        content_type: "eventsPage",
      })
      .then((response) => {
        const allEvents = response.items[0].fields.events || [];

        // Today's date (start of day)
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Filter for past events only
        const pastEvents = allEvents
          .filter((event) => {
            const eventDate = new Date(event.fields.datePicker);
            return !isNaN(eventDate) && eventDate < today;
          })
          // Sort descending: most recent first
          .sort(
            (a, b) =>
              new Date(b.fields.datePicker) - new Date(a.fields.datePicker)
          );

        setContent(pastEvents);
      })
      .catch((error) => console.error(error));
  }, []);

  // Format: "November 2025"
  const formatMonthYear = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  const parseSubtitle = (text) => {
    const parts = text.split(/(\[.*?\]\(.*?\))/g);
    return parts.map((part, index) => {
      const match = part.match(/\[(.*?)\]\((.*?)\)/);
      if (match) {
        return (
          <a
            key={index}
            href={match[2]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {match[1]}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <Page>
      <div className={styles.content}>
        <h1 className={styles.title}>Previous Events</h1>
        {content.length === 0 && (
          <p>No previous events available at the moment.</p>
        )}
        {content.map((project, projectIndex) => (
          <div key={projectIndex}>
            <div className={styles.subtitle}>{project.fields.title}</div>
            <div className={styles.date}>
              {formatMonthYear(project.fields.datePicker)}
            </div>
            {project.fields?.subtitle && (
              <div className={styles.tag}>
                {parseSubtitle(project.fields.subtitle)}
              </div>
            )}
            <div className={styles.imageContainer}>
              <SimpleSlider
                images={project.fields.images.map(
                  (asset) => `https:${asset.fields.file.url}`
                )}
              />
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
}

export default PreviousEventsPage;

// comment
